import ClipboardJS from 'clipboard';
import { Modal as ModalModule, UI } from 'common';
import React, { useContext, useEffect, useRef } from 'react';

const { ModalContext, Modal } = ModalModule;
const { WrappedButton, WrappedButtonType } = UI;

const ResendInviteModal = ({ modalId, data }) => {
	const { activationLink, FirstName, EmailAddress, callback } = data;
	const title = 'Resend Invite';
	const { closeModal } = useContext(ModalContext);
	const clipboardRef = useRef(null);

	useEffect(() => {
		// Initialize ClipboardJS
		clipboardRef.current = new ClipboardJS(
			'.copy-to-clipboard-btn > .p-button'
		);

		// Handle successful copy
		clipboardRef.current.on('success', e => {
			// Clear selection
			e.clearSelection();
			// Notify parent that copy link was clicked
			callback('copyLink');
			// Close modal after successful copy
			closeModal(modalId);
		});

		// Handle copy error
		clipboardRef.current.on('error', e => {
			// Still notify parent and close modal
			callback('copyLink');
			closeModal(modalId);
		});

		return () => {
			if (clipboardRef.current) {
				clipboardRef.current.destroy();
			}
		};
	}, [callback, closeModal, modalId]);

	const onButtonClick = e => {
		const { name } = e.currentTarget;

		// For Copy Link button, let ClipboardJS handle it
		if (name === 'copyLink') {
			// ClipboardJS will handle the click event
			return;
		}

		// For other buttons (Resend Email), handle normally
		callback(name);
		closeModal(modalId);
	};

	return (
		<Modal
			className="account-users resend-invite-modal"
			modalId={modalId}
			header={title}
			hideFooter
		>
			<div className="p-grid">
				<p className="p-col-12">
					Click <b>Resend Email</b> to have us resend the invitation email to{' '}
					{EmailAddress}. This email includes {FirstName}'s account activation
					link.
				</p>
				<p className="p-col-12">
					Click <b>Copy Link</b> to copy {FirstName}'s account activation link
					to your clipboard, so that you can send it to them directly.
				</p>
				<div className="p-col-12">
					<WrappedButton
						buttonType={WrappedButtonType.Primary}
						onClick={onButtonClick}
						dataqa="resend-email"
						label="Resend Email"
						name="resendEmail"
					/>
					<WrappedButton
						buttonType={WrappedButtonType.Secondary}
						onClick={onButtonClick}
						dataqa="copy-link"
						label="Copy Link"
						name="copyLink"
						data-clipboard-text={activationLink}
						className="copy-to-clipboard-btn"
					/>
				</div>
			</div>
		</Modal>
	);
};

export default ResendInviteModal;
